import { render } from "./BannerDropzone.vue?vue&type=template&id=c6772250&scoped=true"
import script from "./BannerDropzone.vue?vue&type=script&lang=js"
export * from "./BannerDropzone.vue?vue&type=script&lang=js"

import "./BannerDropzone.vue?vue&type=style&index=0&id=c6772250&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c6772250"

export default script